import { styled } from '@grupoboticario/flora-react'

export const Header = styled('header', {
  marginBottom: '$4',
  marginTop: '$3'
})
